<template>
  <div class="left-nav">
    <div class="steps-container">
      <div 
        v-for="(step, index) in steps" 
        :key="index"
        class="step-item"
        :class="{
          'completed': step.status === 'completed',
          'active': step.status === 'active',
          'inactive': step.status === 'inactive'
        }"
        @click="handleStepClick(step, index)"
      >
        <div class="step-circle">
          <template v-if="step.status === 'completed'">
            <el-icon><Check /></el-icon>
          </template>
          <template v-else>
            {{ index + 1 }}
          </template>
        </div>
        <div class="step-content">
          <div class="step-title">{{ step.title }}</div>
          <div class="step-subtitle">{{ step.subtitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { Check } from '@element-plus/icons-vue'

const props = defineProps({
  steps: {
    type: Array,
    default: () => [
      {
        title: '问题输入',
        subtitle: '明确需求与边界',
        status: 'completed'
      },
      {
        title: '技术路径分析',
        subtitle: '匹配可行技术路线',
        status: 'active'
      },
      {
        title: '解决方案生成',
        subtitle: '输出完整解决方案',
        status: 'inactive'
      }
    ]
  }
})

const emit = defineEmits(['step-click'])

const handleStepClick = (step, index) => {
  emit('step-click', step, index)
}
</script>

<style scoped lang="scss">
.left-nav {
  width: 240px;
  background-color: #fff;
  padding: 40px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  
  .steps-container {
    position: relative;
    padding-left: 40px;
  }
  
  .steps-container::before {
    content: '';
    position: absolute;
    left: 80px;
    top: 20px;
    bottom: 30px;
    width: 2px;
    background-image: repeating-linear-gradient(
      to bottom,
      #d9d9d9 0px,
      #d9d9d9 6px,
      transparent 6px,
      transparent 12px
    );
    z-index: 1;
  }
  
  .step-item {
    position: relative;
    margin-bottom: 40px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 20px 0px 20px 20px;
    
    &.active {
      background: linear-gradient(to right, white 50%, #9ED4FB);
      // padding-right: 20px;
      // margin-right: -20px;
      border-right: 4px solid #333;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .step-circle {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background-color: #fff;
    color: #333;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 2px solid #d9d9d9;
    z-index: 2;
    
    .el-icon {
      font-size: 20px;
    }
  }
  
  .step-content {
    flex: 1;
  }
  
  .step-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
  }
  
  .step-subtitle {
    font-size: 14px;
    color: #999;
  }
  
  .step-item.completed {
    .step-circle {
      color: #333;
      border-color: #333;
    }
  }
  
  .step-item.active {
    .step-circle {
      background-color: #fff;
      color: #333;
      border-color: #333;
    }
  }
  
  .step-item.inactive {
    .step-circle {
      background-color: #fff;
      color: #999;
      border-color: #d9d9d9;
    }
    
    .step-title {
      color: #999;
    }
    
    .step-subtitle {
      color: #d9d9d9;
    }
  }
}
</style>